interface XIconProps {
  className?: string;
}

const XIcon = ({ className }: XIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      fill="currentColor"
      className={className}
    >
      <path d="M10.691 1.11084H12.6588L8.35965 6.02454L13.4173 12.711H9.45721L6.35551 8.65569L2.80645 12.711H0.837403L5.43582 7.45523L0.583984 1.11084H4.64463L7.4483 4.81753L10.691 1.11084ZM10.0003 11.5331H11.0907L4.05213 2.22683H2.882L10.0003 11.5331Z" />
    </svg>
  );
};

export default XIcon;
